import React, { useMemo } from "react";
import { navigate } from "gatsby";

import { BoxButtonTypes } from "../../types/button";

import { COLORS } from "../../utils/colors";
import ICONS from "../../constants/icons";
import MENU_PATHS from "../../constants/menu";
import ICON_SIZE from "../icon/enums";

import Icon from "../icon/Icon";
import { GatsbyImage } from "gatsby-plugin-image";
import Tag from "../tag";

const BoxButton = ({
  backgroundImage,
  backgroundIcon,
  tags,
  date,
  description,
  icon,
  path = MENU_PATHS.NEWS,
  title,
  boxNumber,
  readMore = true,
  fullDescription = false,
  noHover = false,
  uri = "",
  active = false,
  customButtonText,
}: BoxButtonTypes) => {
  const boxNumberClass = useMemo(() => {
    return `-boxNumber-${boxNumber}`;
  }, [boxNumber]);

  const handleClick = (uri: string) => {
    if (path === MENU_PATHS.NEWS) {
      navigate(`${path}/${uri}/`);
    } else {
      navigate(path);
    }
  };

  return (
    <button
      className={`a-button__boxButton text-left column space-between ${boxNumberClass} ${
        backgroundImage ? "-backgroundImage" : ""
      } ${noHover ? "-noHover" : ""} ${active ? "-active" : ""}`}
      onClick={!noHover ? () => handleClick(uri || "") : undefined}
    >
      <div className="fullWidth">
        {backgroundImage && (
          <div className="-mb15">
            {backgroundImage && typeof backgroundImage === "string" && (
              <img src={backgroundImage} alt="" />
            )}
            {backgroundImage && typeof backgroundImage !== "string" && (
              <GatsbyImage image={backgroundImage.gatsbyImageData} alt="" />
            )}
          </div>
        )}

        {tags?.length && date && (
          <div className="aligned-center -gap10 flex-wrap -mb10">
            <Tag tags={tags} />
            <span className="-title text-lightBlue">{date}</span>
          </div>
        )}

        <div className={`-mb10 ${icon || backgroundIcon ? "column -gap15 aligned-center" : ""}`}>
          {icon && (
            <div className="a-button__boxButton__icon justify-center aligned-center">
              <Icon name={icon} color={COLORS.white} size={ICON_SIZE.SIZE_40} />
            </div>
          )}
          {backgroundIcon && (
            <div className="a-button__boxButton__icon justify-center aligned-center">
              <GatsbyImage image={backgroundIcon.gatsbyImageData} alt="" />
            </div>
          )}
          <p
            className={`a-button__boxButton__titleSection__title -title boxTitle ${
              icon ? "text-centered" : ""
            }`}
          >
            {title}
          </p>
        </div>
        <p
          className={`a-button__boxButton${
            fullDescription ? "__fullDescription" : "__description"
          } text-lightBlue ${icon ? "text-centered" : ""} description14`}
        >
          {description}
        </p>
      </div>

      {readMore && !noHover && (
        <div
          className={`row -column-gap4 -mt10 -readMoreBtn ${
            customButtonText ? "justify-center fullWidth" : ""
          }`}
        >
          <p className="-readMore">{customButtonText || "Read more"}</p>
          <Icon name={ICONS.SECOND_RIGHT_ARROW} />
        </div>
      )}
    </button>
  );
};

export default BoxButton;
